/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { colors } from "@farmlands/mui-theme";
import { Box, Link, styled } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";

import MaterialSymbol from "../../../../components/MaterialSymbol";
import Typography from "../../../../components/Typography";
import TestIds from "../../../../testIds";
import { useBranch } from "../../../../util/useBranch";
import { selectPickupStores } from "../../../stores/storage/stores.slice";

import StoreAvailabilityModal from "./StoreAvailabilityModal";

const FlexRow = styled(Box)({
  display: "flex",
  gap: "8px",
  alignItems: "center",
});

export const StoreModalOpenLink = ({ name, productId }: { name: string; productId: number }) => {
  const [openModal, setOpenModal] = React.useState(false);
  const stores = useSelector(selectPickupStores);
  const branchId = useBranch();
  const selectedStore = stores.find((x) => x.inventorySiteId === branchId);

  return (
    <FlexRow data-testid={TestIds.feat.stock.storeAvailabilitiesLink}>
      <MaterialSymbol sx={{ color: colors.primary500 }}>location_on</MaterialSymbol>
      <Typography
        variant="body2"
        color={"primary500"}
        component={Link}
        onClick={() => setOpenModal(true)}
      >
        {name}
      </Typography>

      <StoreAvailabilityModal
        open={openModal}
        setOpen={setOpenModal}
        productId={productId}
        selectedStore={selectedStore}
        testId={TestIds.feat.stock.storeAvailabilitiesModal}
      />
    </FlexRow>
  );
};
